














import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import getPositionInElement from '@/plugins/tegaki/getPositionInElement'
import _ from 'lodash'

export type Stroke = {
  x: number
  y: number
}

@Component
export default class TegakiCanvas extends Vue {
  @Prop()
  width!: number

  @Prop()
  height!: number

  @Prop()
  mode!: string

  @Prop()
  strokes!: Stroke[][]

  private ctx: CanvasRenderingContext2D | null = null
  private isActive = false
  private currentStroke: Stroke[] = []

  private handleResize = _.throttle(this.draw, 500)

  private debouncedHandleResize = _.debounce(this.handleResize, 300)

  @Watch('strokes', { deep: true })
  private onStrokes() {
    this.draw()
  }

  @Watch('currentStroke')
  private onCurrentStroke() {
    this.draw()
  }

  private mounted() {
    window.addEventListener('resize', this.debouncedHandleResize)

    this.ctx = (this.$el as HTMLCanvasElement).getContext('2d')
    if (this.ctx) {
      this.ctx.lineWidth = 2
      this.ctx.lineCap = 'round'
      this.ctx.lineJoin = 'round'
    }
  }

  private beforeDestroy() {
    window.removeEventListener('resize', this.debouncedHandleResize)
  }

  //
  // キャンバスに描画
  //
  private drawStroke(items: Stroke[]) {
    if (!this.ctx) return

    this.ctx.beginPath()

    items.forEach((item, i) => {
      if (this.ctx) this.ctx[i > 0 ? 'lineTo' : 'moveTo'](item.x, item.y)
    })

    this.ctx.stroke()
  }
  draw() {
    if (!this.ctx) return
    this.ctx.beginPath()

    this.ctx.clearRect(0, 0, this.width, this.height)

    this.strokes.concat([this.currentStroke]).forEach((strokes, i) => {
      if (this.ctx) this.ctx.strokeStyle = this.mode === 'eraser' && i === this.strokes.length ? '#f00' : '#000'
      this.drawStroke(strokes)
    })
  }

  //
  // 手書きイベント
  //
  private start(event: TouchEvent | Touch) {
    if (this.isActive) return

    this.isActive = true

    switch (this.mode) {
      case 'pen':
        this.currentStroke.push(getPositionInElement(event))
        break
      case 'eraser':
        this.currentStroke.push(getPositionInElement(event))
        break
    }
  }
  private move(event: TouchEvent | Touch) {
    if (!this.isActive) return

    switch (this.mode) {
      case 'pen':
        this.currentStroke.push(getPositionInElement(event))
        break
      case 'eraser':
        this.currentStroke.push(getPositionInElement(event))
        break
    }
  }
  private stop() {
    if (!this.isActive) return

    this.isActive = false

    switch (this.mode) {
      case 'pen': {
        const strokes = this.strokes.concat([this.currentStroke])
        this.currentStroke = []
        this.$emit('stop-pen', strokes)
        break
      }
      case 'eraser': {
        let newStrokes: Stroke[][] = []

        this.strokes.forEach((stroke) => {
          let isIntersect = false

          for (let i = 1; i < stroke.length; i++) {
            const xmn1 = Math.min(stroke[i].x, stroke[i - 1].x)
            const xmx1 = Math.max(stroke[i].x, stroke[i - 1].x)
            const ymn1 = Math.min(stroke[i].y, stroke[i - 1].y)
            const ymx1 = Math.max(stroke[i].y, stroke[i - 1].y)

            for (let j = 1; j < this.currentStroke.length; j++) {
              const xmn2 = Math.min(this.currentStroke[j].x, this.currentStroke[j - 1].x)
              const xmx2 = Math.max(this.currentStroke[j].x, this.currentStroke[j - 1].x)
              const ymn2 = Math.min(this.currentStroke[j].y, this.currentStroke[j - 1].y)
              const ymx2 = Math.max(this.currentStroke[j].y, this.currentStroke[j - 1].y)

              if (xmn1 <= xmx2 && ymn1 <= ymx2 && xmn2 <= xmx1 && ymn2 <= ymx1) {
                isIntersect = true
              }
            }
          }

          // 交差しない場合は配列に格納
          if (!isIntersect) newStrokes.push(stroke)
        })

        this.currentStroke = []
        this.$emit('stop-eraser', newStrokes)
        break
      }
    }
  }

  //
  // マウスイベント
  //
  onMouseDown(event: TouchEvent | Touch) {
    this.start(event)
  }
  onMouseMove(event: TouchEvent | Touch) {
    this.move(event)
  }
  onMouseUp() {
    this.stop()
  }
  onMouseLeave() {
    this.stop()
  }

  //
  // タッチイベント
  //
  onTouchStart(event: TouchEvent | Touch) {
    this.start(event)
  }
  onTouchMove(event: TouchEvent | Touch) {
    this.move(event)
  }
  onTouchEnd() {
    this.stop()
  }
}
